import { CoralogixRum } from '@coralogix/browser'

// Matched on browser message text (Chrome, Firefox, Safari); extend if a browser words it differently
const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|is not a valid JavaScript MIME type/

const RELOADED_FROM_BUILDS_KEY = 'error-boundary:chunk-reloaded-from'
const PENDING_RELOAD_KEY = 'error-boundary:chunk-reload-pending'

const currentBuild = () => String(import.meta.env.VITE_BUILD_VERSION)

export const isChunkLoadError = (error: unknown) =>
  error instanceof Error && CHUNK_LOAD_ERROR.test(error.message)

// Once per build per tab: remember every build reloaded from, so alternating builds can't loop either.
export const reloadForStaleChunk = () => {
  if (!navigator.onLine) return
  const build = currentBuild()
  try {
    const builds = sessionStorage.getItem(RELOADED_FROM_BUILDS_KEY)?.split(',') ?? []
    if (builds.includes(build)) return
    sessionStorage.setItem(RELOADED_FROM_BUILDS_KEY, [...builds, build].join(','))
    sessionStorage.setItem(PENDING_RELOAD_KEY, build)
  } catch {
    return
  }
  window.location.reload()
}

// Logged on the load after the reload, since events queued right before reload() can be lost.
export const reportStaleChunkReload = () => {
  try {
    const from = sessionStorage.getItem(PENDING_RELOAD_KEY)
    if (!from) return
    sessionStorage.removeItem(PENDING_RELOAD_KEY)
    CoralogixRum.info(
      'stale_chunk_reload',
      { from, to: currentBuild() },
      { feature: 'stale-chunk' },
    )
  } catch {
    return
  }
}
